var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabla sombra"},[_c('b-table',{staticClass:"table-container",attrs:{"fields":_vm.fields,"items":_vm.deliveries,"responsive":""},scopedSlots:_vm._u([{key:"cell(store)",fn:function({item}){return [_c('div',[_vm._v(_vm._s(item.store? item.store.name : '-'))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }